// extracted by mini-css-extract-plugin
module.exports = {"flexRow":"CnvoP2mE","flexColumn":"jEqRM5nE","title":"vWAzhCWd","subtitle":"c8mYM_EX"};